import React from "react";

import MultipleAccountsHelpGuide from "../Accounts/components/MultipleAccountsHelpGuide";
import { Modal } from "../ui";

type ConnectLinkedinModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onOpenCredentialsSidebar?: () => void;
  onLoginWithExtension?: () => void;
};

const optionCardClassName =
  "flex h-full w-full flex-col justify-start rounded-[12px] border border-border-grey bg-medium-grey p-5 text-left transition-colors hover:bg-white";

export default function ConnectLinkedinModal({
  isOpen,
  onClose,
  onOpenCredentialsSidebar,
  onLoginWithExtension,
}: ConnectLinkedinModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      title="How do you want to automate your LinkedIn account?"
      closeIconSrc="/icons/x_circle.svg"
      panelClassName="bg-white p-4"
      headerClassName="rounded-t-[12px] border border-border-grey border-b-0 bg-white px-4 pt-3"
      titleClassName="text-md"
      bodyClassName="rounded-b-[12px] border border-t-0 border-border-grey bg-white px-4 py-4 pt-2"
    >
      <div className="grid grid-cols-1 items-stretch gap-4 md:grid-cols-2">
        <button
          type="button"
          className={optionCardClassName}
          onClick={() => {
            onOpenCredentialsSidebar?.();
            onClose();
          }}
        >
          <div className="mb-2 flex items-center gap-2">
            <img
              src="/icons/linkedin.svg"
              alt=""
              aria-hidden="true"
              className="h-[18px] w-[18px]"
            />
            <h3 className="text-xs font-semibold text-dark-black">Automate on Cloud</h3>
          </div>
          <p className=" text-xs text-dark-grey">
            Connect your LinkedIn account securely and let innLead execute your workflows from
            our cloud, even when your computer is offline.
          </p>
        </button>

        <button
          type="button"
          className={optionCardClassName}
          onClick={() => {
            onLoginWithExtension?.();
            onClose();
          }}
        >
          <div className="mb-2 flex items-center gap-2">
            <img src="/icons/linkedin.svg" alt="" aria-hidden="true" className="h-[18px] w-[18px]" />
            <h3 className="text-xs font-semibold text-dark-black">Automate With Extension</h3>
          </div>
          <p className=" text-xs text-dark-grey">
            Run LinkedIn automation through the account already logged into this Chrome
            browser. Use a separate Chrome profile for each LinkedIn account.
          </p>
        </button>
      </div>

      <p className="mt-4 text-xs text-dark-grey">
        You can use different automation methods for different LinkedIn accounts.
      </p>

      <MultipleAccountsHelpGuide variant="compact" defaultExpanded={false} className="mt-4" />
    </Modal>
  );
}
